import React from 'react';
import { Btn } from 'components/btn/Btn';
import { DealCard } from './DealCard';
import { DealUIObject } from 'common/api/deals/types';
import { Brand } from 'common/features/store/duck/search-generic/utils/searchResultBrandsToBrands';
import { DealsModal, DealsModalProps } from './DealsModal';
import { createStyles } from 'utils/createStyle';
import { useHistory } from 'react-router-dom';
import { getPath, Routes } from 'routes';

export interface DealUIObjectWithBrand extends DealUIObject {
    brand?: Brand;
}

const dealsSectionStyles = createStyles({
    container: ['mb-8 mt-4 mx-auto flex flex-col items-center justify-center max-w-[1024px]'],
    title: ['mb-4 text-dark-blue text-[24px] md:text-[29px] font-semibold'],
    dealsGrid: ['w-full flex flex-row flex-wrap items-start'],
    shopAllButton: ['mt-[28px] md:mt-[40px]'],
});

export interface DealsSectionProps {
    doNotFetchOwnDeals?: boolean;
    hideTitle?: boolean;
    hideMoreLink?: boolean;
    deals: DealUIObjectWithBrand[];
    location: DealsModalProps['location'];
}

export const DealsSection = ({ deals, hideTitle, hideMoreLink, location }: DealsSectionProps) => {
    const history = useHistory();
    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalDeal, setModalDeal] = React.useState<DealUIObjectWithBrand | undefined>(undefined);

    const goToAllDeals = () => {
        history.push(getPath(Routes.ShopTopDeals, {}));
    };

    if (!deals || !deals.length) {
        return null;
    }

    return (
        <section className={dealsSectionStyles.container}>
            {!hideTitle && (
                <h3 className={dealsSectionStyles.title}>Top Online Deals &amp; Coupons</h3>
            )}

            <div className={dealsSectionStyles.dealsGrid}>
                {deals.map((deal, index) => (
                    <DealCard
                        key={index}
                        deal={deal}
                        brand={deal.brand}
                        onClick={() => {
                            setModalDeal(deal);
                            setModalOpen(true);
                        }}
                    />
                ))}
            </div>

            {!hideMoreLink && (
                <Btn className={dealsSectionStyles.shopAllButton} onClick={goToAllDeals}>
                    Shop All
                </Btn>
            )}

            {modalDeal && (
                <DealsModal
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    dealWithBrand={modalDeal}
                    location={location}
                />
            )}
        </section>
    );
};
